import React, { useEffect, useState } from "react";
import { Bindings } from "./Bindings";

let domainShad = "https://www.shad.es";
const inDevMode = process.env.NODE_ENV === "development";
const inTestMode = false;
if (inDevMode) {
  domainShad = "http://localhost:3000/app-para-tu-moto";
}
if (inTestMode) {
  domainShad = "https://preprod.shad.es";
}

export const Selector = () => {
  const url_motos = domainShad + "/assets/json/marca_modelo_anyo.json";
  const url_bindings = domainShad + "/assets/json/fijacion_modelo.json";
  const url_articles = domainShad + "/assets/json/articulos.json";

  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [years, setYears] = useState([]);

  const [modelCode, setModelCode] = useState("");
  const [products, setProducts] = useState([]);

  const [selectBrand, setSelectBrand] = useState(false);
  const [selectModel, setSelectModel] = useState(false);
  const [selectYear, setSelectYear] = useState("0");

  const [motoData, setMotoData] = useState([]);
  const [bindData, setBindData] = useState([]);
  const [articleData, setArticleData] = useState([]);

  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get("lang") ? urlParams.get("lang") : "es";
  // Selecciona una marca
  const selectBrandES = "Selecciona una marca";
  const selectBrandCA = "Selecciona una marca";
  const selectBrandEN = "Select a brand";
  const selectBrandFR = "Sélectionnez une marque";
  const selectBrandIT = "Seleziona una marca";
  // Selecciona un Modelo
  const selectModelES = "Selecciona un Modelo";
  const selectModelCA = "Selecciona un Model";
  const selectModelEN = "Select a Model";
  const selectModelFR = "Sélectionnez un modèle";
  const selectModelIT = "Seleziona un modello";
  // Selecciona un año
  const selectYearES = "Selecciona un año";
  const selectYearCA = "Selecciona un any";
  const selectYearEN = "Select a year";
  const selectYearFR = "Sélectionnez une année";
  const selectYearIT = "Seleziona un anno";
  // Todos los años
  const selectAllYearsES = "Todos los años";
  const selectAllYearsCA = "Tots els anys";
  const selectAllYearsEN = "All years";
  const selectAllYearsFR = "Toutes les années";
  const selectAllYearsIT = "Tutti gli anni";
  // Buscar fijaciones
  const searchButtonES = "Buscar fijaciones";
  const searchButtonCA = "Buscar fixacions";
  const searchButtonEN = "Search fittings";
  const searchButtonFR = "Rechercher des raccords";
  const searchButtonIT = "Ricerca raccordi";

  let selectBrandValue = "";
  let selectModelValue = "";
  let selectYearValue = "";
  let selectAllYearsValue = "";
  let searchButtonValue = "";

  if (lang === "es") {
    selectBrandValue = selectBrandES;
    selectModelValue = selectModelES;
    selectYearValue = selectYearES;
    selectAllYearsValue = selectAllYearsES;
    searchButtonValue = searchButtonES;
  } else if (lang === "ca") {
    selectBrandValue = selectBrandCA;
    selectModelValue = selectModelCA;
    selectYearValue = selectYearCA;
    selectAllYearsValue = selectAllYearsCA;
    searchButtonValue = searchButtonCA;
  } else if (lang === "it") {
    selectBrandValue = selectBrandIT;
    selectModelValue = selectModelIT;
    selectYearValue = selectYearIT;
    selectAllYearsValue = selectAllYearsIT;
    searchButtonValue = searchButtonIT;
  } else if (lang === "fr") {
    selectBrandValue = selectBrandFR;
    selectModelValue = selectModelFR;
    selectYearValue = selectYearFR;
    selectAllYearsValue = selectAllYearsFR;
    searchButtonValue = searchButtonFR;
  } else {
    selectBrandValue = selectBrandEN;
    selectModelValue = selectModelEN;
    selectYearValue = selectYearEN;
    selectAllYearsValue = selectAllYearsEN;
    searchButtonValue = searchButtonEN;
  }

  useEffect(() => {
    const fetchData = async () => {
      const motoResponse = await fetch(url_motos);
      const motoDataRes = await motoResponse?.json();
      setMotoData(motoDataRes);

      const bindingResponse = await fetch(url_bindings);
      const bindDataRes = await bindingResponse?.json();
      setBindData(bindDataRes);

      const articleResponse = await fetch(url_articles);
      const articleDataRes = await articleResponse?.json();
      setArticleData(articleDataRes);
    };

    fetchData();
  }, [url_motos, url_bindings, url_articles]);

  useEffect(() => {
    // setProducts(mock)
    if (articleData.length > 0 && bindData.length > 0 && motoData.length > 0) {
      loadLocalStorage();
    }
  }, [articleData, bindData, motoData]);

  useEffect(() => {
    getBrands();
  }, [motoData]);

  useEffect(() => {
    getModels();
  }, [selectBrand]);

  useEffect(() => {
    getYears();
  }, [selectModel]);

  const loadLocalStorage = () => {
    const localSelectedBrand = localStorage.getItem("selectedBrand");
    const localSelectedModel = localStorage.getItem("selectedModel");
    const localSelectedYear = localStorage.getItem("selectedYear");

    if (!localSelectedYear) {
      localStorage.setItem("selectedYear", "0");
      setSelectYear("0");
    }

    if (localSelectedBrand) {
      setSelectBrand(localSelectedBrand);
      document.getElementById("modelChange").disabled = false;
    }

    if (localSelectedModel) {
      setSelectModel(localSelectedModel);
      document.getElementById("yearChange").disabled = false;
    }

    if (localSelectedYear) {
      setSelectYear(localSelectedYear);
      document.getElementById("changeModel").disabled = false;
    }

    if (localSelectedBrand && localSelectedModel && localSelectedYear) {
      setTimeout(() => {
        const changeModelEl = document.getElementById("changeModel");
        changeModelEl.click();
      }, 500);
      //searchMotoFirstTime(localSelectedModel, selectYear)
    }
  };

  const getBrands = async () => {
    setBrands([...new Set(motoData.map((moto) => moto.Marca))]);
  };

  const getModels = async () => {
    const dataFiltrada = motoData.filter((moto) => moto.Marca === selectBrand);
    setModels([...new Set(dataFiltrada.map((moto) => moto.Modelo))]);
  };

  const getYears = async () => {
    const dataFiltrada = motoData.filter((moto) => moto.Modelo === selectModel);
    if (dataFiltrada.length > 0) {
      setModelCode(dataFiltrada[0]["Codigo Modelo"]);
    }
    setYears(dataFiltrada.map((moto) => moto.year));
  };

  const getBindings = async () => {
    let dataFiltered = [];
    if (selectYear === "0") {
      dataFiltered = bindData.filter(
        (fijacion) =>
          fijacion.Fijacion_Modelo === modelCode &&
          !fijacion.Fijacion.startsWith("REF_")
      );
    } else {
      dataFiltered = bindData.filter(
        (fijacion) =>
          fijacion.Fijacion_Modelo === modelCode &&
          fijacion.Fijacion_Anyo === parseInt(selectYear) &&
          !fijacion.Fijacion.startsWith("REF_")
      );
    }
    dataFiltered = [
      ...new Set(dataFiltered.map((fijacion) => fijacion.Fijacion)),
    ];

    return articleData.filter((articulo) =>
      dataFiltered.includes(articulo.SKU)
    );
  };

  const getArticles = async (bindings) => {
    bindings.map((bind) => {
      let fetchUrl;
      let langApiStr = "";
      if (lang !== "es" && lang.length > 0) {
        langApiStr = "/" + lang;
      }
      fetchUrl =
        domainShad +
        langApiStr +
        "/wc-api/v3/products?filter[sku]=" +
        bind.SKU +
        "&consumer_key=ck_8a1fd76e94c8aa5e341d76e0825dc56ce0a4114a&consumer_secret=cs_26db3ac0e112940c5e3d31d065445c3f07aa85ba";
      if (inDevMode) {
        fetchUrl = domainShad + "/assets/json/products.json";
      }
      if (inTestMode) {
        fetchUrl = domainShad + "/app-para-tu-moto/assets/json/products.json";
      }
      return fetch(fetchUrl, { mode: "no-cors" })
        .then((response) => {
          if (!response.ok) {
            throw new Error("HTTP error " + response.status);
          }
          return response.json();
        })
        .then((data) => {
          if (inDevMode || inTestMode) {
            const productFound = data.products.find((x) => x.sku === bind.SKU);
            if (productFound) {
              setProducts((ptm) => [...ptm, productFound]);
            }
          } else {
            const newProduct = data.products[0];
            if (!products.find((x) => x.id === newProduct.id)) {
              setProducts((ptm) => [...ptm, newProduct]);
            }
          }
        })
        .catch(function (error) {
          console.log("Fetch failed: ", error);
        });
    });
  };

  const changeBrand = (e) => {
    setProducts([]);
    localStorage.setItem("selectedBrand", e.target.value);
    localStorage.setItem("selectedModel", null);
    setSelectBrand(e.target.value);
    document.getElementById("modelChange").disabled = false;
  };

  const changeModel = (e) => {
    setProducts([]);
    localStorage.setItem("selectedModel", e.target.value);
    setSelectModel(e.target.value);
    document.getElementById("yearChange").disabled = false;
  };

  const changeYear = (e) => {
    setProducts([]);
    localStorage.setItem("selectedYear", e.target.value);
    setSelectYear(e.target.value);
  };

  const searchMoto = async (e) => {
    e.preventDefault();
    //if (selectBrand & selectModel) {
    setProducts([]);
    const bindings = await getBindings();
    getArticles(bindings);
    //}
  };

  // const searchMotoFirstTime = async (selectModel, selectYear) => {
  //     let modelCode = ''

  //     const dataMotoFiltrada = motoData.filter(moto => moto.Modelo === selectModel)
  //     if (dataMotoFiltrada.length > 0) {
  //         modelCode = dataMotoFiltrada[0]["Codigo Modelo"]
  //     }

  //     let dataFiltrada = []
  //     if (selectYear === "0") {
  //         dataFiltrada = bindData.filter(fijacion => fijacion.Fijacion_Modelo === modelCode && !fijacion.Fijacion.startsWith('REF_'))
  //     } else {
  //         dataFiltrada = bindData.filter(fijacion => fijacion.Fijacion_Modelo === modelCode && fijacion.Fijacion_Anyo === parseInt(selectYear) && !fijacion.Fijacion.startsWith('REF_'))
  //     }

  //     dataFiltrada = [...new Set(dataFiltrada.map(bind => bind.Fijacion))]

  //     const articlesFiltered = articleData.filter(article => dataFiltrada.includes(article.SKU))

  //     getArticles(articlesFiltered)
  //     console.log(products);
  // }

  if (
    articleData.length === 0 &&
    bindData.length === 0 &&
    motoData.length === 0
  ) {
    return null;
  }

  return (
    <div className="config-area fijaciones-widget  container-scroll">
      <form>
        <div className="selected-group">
          <input name="lang" type="hidden" value={lang} />
          <select
            value={selectBrand}
            name="brandChange"
            id="brandChange"
            onChange={changeBrand}
          >
            <option value="">{selectBrandValue}</option>
            {brands.map((marca, index) => (
              <option key={index} value={marca}>
                {marca}
              </option>
            ))}
          </select>
          <select
            value={selectModel}
            name="modelChange"
            id="modelChange"
            disabled
            onChange={changeModel}
          >
            <option value="">{selectModelValue}</option>
            {models.map((modelo, index) => (
              <option key={index} value={modelo}>
                {modelo}
              </option>
            ))}
          </select>
          <select
            value={selectYear ? selectYear : "0"}
            name="yearChange"
            id="yearChange"
            disabled
            onChange={changeYear}
          >
            {years.length < 1 ? (
              <option value="">{selectYearValue}</option>
            ) : (
              <option value="0">{selectAllYearsValue}</option>
            )}
            {years.map((year, index) => (
              <option key={index} value={year}>
                {year}
              </option>
            ))}
          </select>
          <button id="changeModel" type="submit" onClick={searchMoto}>
            {searchButtonValue}
          </button>
        </div>
      </form>
      <div className="fijaciones-block">
        {products.length === 0 ? (
          <></>
        ) : (
          <Bindings
            lang={lang}
            articulos={products}
            modelCode={modelCode}
            bindingsJson={bindData}
            showYears={selectYear && selectYear === "0"}
          />
        )}
      </div>
    </div>
  );
};
